/**
 * Polyfill for ReactDOM.findDOMNode
 * React 19 removed findDOMNode, but react-transition-group 4.4.5 still uses it
 * This polyfill reimplements the basic functionality
 */

import React from 'react';

const findDOMNode = (component) => {
  if (component == null) {
    return null;
  }

  if (component.nodeType === 1 || component.nodeType === 9) {
    return component;
  }

  // For functional components or class components with refs
  if (typeof component === 'object') {
    // If it's a ref object
    if (component.current !== undefined) {
      return component.current;
    }

    // If it's a class component instance, look for _reactRootContainer or similar
    // This is a workaround since React 19 doesn't expose internal properties
    const fiber = component._owner || component._fiber;
    if (fiber) {
      let fiberNode = fiber;
      while (fiberNode) {
        if (fiberNode.stateNode && fiberNode.stateNode.nodeType) {
          return fiberNode.stateNode;
        }
        fiberNode = fiberNode.child;
      }
    }
  }

  return null;
};

// Inject the polyfill into ReactDOM
if (typeof window !== 'undefined') {
  const ReactDOM = require('react-dom');
  if (ReactDOM && !ReactDOM.findDOMNode) {
    ReactDOM.findDOMNode = findDOMNode;
  }
}

export default findDOMNode;
